import { INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'

export interface messagingTypes {
  type: INLINE_MESSAGE_VARIANTS
  label: string
}

const { ALERT, INFO, WARNING } = INLINE_MESSAGE_VARIANTS

export const pushNotificationsMessaging = (enabled: boolean): messagingTypes => ({
  type: enabled ? INFO : ALERT,
  label: `Push Notifications are ${enabled ? 'enabled' : 'disabled'}`,
})
export const locationMessaging = (enabled: boolean): messagingTypes => ({
  type: enabled ? INFO : ALERT,
  label: `Location is ${enabled ? 'enabled' : 'disabled'}`,
})
export const appMessaging = (enabled: boolean): messagingTypes => ({
  type: enabled ? INFO : ALERT,
  label: `App is turned ${enabled ? 'on' : 'off'}`,
})
export const drivingMessaging = (isDriving: boolean, atFacility: boolean): messagingTypes =>
  isDriving
    ? {
        type: WARNING,
        label: 'Driver is moving \u2014 avoid texting them',
      }
    : {
        type: atFacility ? INFO : ALERT,
        label: `Driver is${atFacility ? ' stopped at a facility' : "n't moving"}`,
      }

export const NEVER_TRACKED: string = 'This user\u2019s location has never been tracked.'
export const NO_ERROR: string = 'No error messages yet.'
export const NEVER_SIGNED_IN: string = 'Has not signed in yet.'

export enum sourceTypes {
  MANUAL = 'Manual',
  LOCATION_SMART = 'Location Smart',
  APP = 'React Native',
}

interface locationsColunmnsTypes {
  label: string
  key: string
  size: string
}

export const driverLocationsColumnOrder: locationsColunmnsTypes[] = [
  { label: 'Shipment ID', key: 'id', size: 'col-md-1' },
  { label: 'Source', key: 'source', size: 'col-md-2' },
  { label: 'Date', key: 'date', size: 'col-md-1' },
  { label: 'Coordinates', key: 'coordinates', size: 'col-md-2' },
  { label: 'Alt/Speed', key: 'altSpeed', size: 'col-md-2' },
  { label: 'Notes', key: 'notes', size: 'col-md-2' },
  { label: 'Processed at', key: 'processed', size: 'col-md-2' },
]
